import { v4 as uuidv4 } from 'uuid';
import { FFF_ANON_ID_COOKIE_NAME } from '@fff-web/constants';
import { getCookie } from './cookies';

export const GTB_UUID_STORAGE_KEY = 'FFF_gtb_uuid';

/** Reads a localStorage ID, creating it on first use; `''` outside the browser. */
export const getOrCreateStoredId = (key: string) => {
  if (typeof window === 'undefined') return '';
  if (!localStorage.getItem(key)) localStorage.setItem(key, uuidv4());
  return localStorage.getItem(key) || '';
};

/** The legacy anonymous ID. Optimizely keeps using it until each flag's own cutover. */
export const getGtbUUID = () => getOrCreateStoredId(GTB_UUID_STORAGE_KEY);

/** The anonymous LD key: `fff_anon_id` (written by maui) when set, else the legacy ID. */
export const getUUID = () => {
  if (typeof window === 'undefined') return '';
  return getCookie(FFF_ANON_ID_COOKIE_NAME) || getGtbUUID();
};
